import './datepicker'
import './dropzone'
import './duplicate-name-confirmation'
import './confirm-additional-items'
import './form-save-shortcut'
import './form-hint-monitor'
import formattedTimestamp from './formatted-timestamp'
import './marketplace-archive-confirmation'
import availableModals from './modal-citizen/available-modals'
import setupModalCitizen from './modal-citizen/setup'
import './multi-file-upload-wrapper'
import './select-navigate'
import './sidepane'
import './submit_trigger'
import './../sections/quick-search'
import setupPeriodPickerTrigger from './setup-period-picker-trigger'

onDomLoad(function ($dom) {
  formattedTimestamp($dom[0])
  setupPeriodPickerTrigger($dom[0])
})

setupModalCitizen(availableModals)
